import { render } from "./ReportAdmin.vue?vue&type=template&id=0ebbd358&scoped=true"
import script from "./ReportAdmin.vue?vue&type=script&lang=js"
export * from "./ReportAdmin.vue?vue&type=script&lang=js"

import "./ReportAdmin.vue?vue&type=style&index=0&id=0ebbd358&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebbd358"]])

export default __exports__